<template>
    <div>
        <el-divider></el-divider>
        <div>
            <input ref="fileInput" type="file" accept=".xlsx" @change="onFileChange" />
            <el-button type="success" style="margin-left: 100px;" @click="importExcel">导入数据</el-button>
            <el-link type="success" href="https://bjlcyq.cn/download/WXCW81/Muban.xlsx" style="margin-left: 100px;">下载模板</el-link>
            <el-link type="warning" href="https://bjlcyq.cn/download/WXCW81/Demo.xlsx" style="margin-left: 100px;">下载Demo</el-link>
            <el-result v-if="errorMessage" style="margin-top: 200px;" icon="error" title="导入失败" :subTitle="errorMessage">
            </el-result>
            <el-result v-if="successVisible" style="margin-top: 200px;" icon="success" title="导入成功">
            </el-result>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            file: null,
            errorMessage: "",
            successVisible: false,
        };
    },
    methods: {
        onFileChange(e) {
            let that = this;
            const files = e.target.files;
            if (!files || files.length === 0) return;
            // 每次选择自动替换
            that.file = files[0];
        },
        importExcel() {
            let that = this;
            if (!that.file) {
                that.$message.error("请先选择文件");
                return;
            }
            that.errorMessage = "";
            that.successVisible = false;
            //显示进度条
            that.loadingInstance = that.$loading({
                lock: true,
                text: '准备中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.6)'
            });
            const formData = new FormData();
            formData.append('file', that.file);

            that.axios.post('WXCW81/ImportExcel', formData).then((response) => {
                if (response.data.code === 101) {
                    that.taskId = response.data.data;
                    that.startPolling();
                } else {
                    that.$message.error(response.data.msg);
                }
            }).catch((error) => {
                that.$message.error("请刷新页面: " + (that.errorMessage = error.message));
                that.loadingInstance.close();
                that.$message.error(that.errorMessage = "请重新选择文件或者刷新页面");
            });
        },
        startPolling() {
            let that = this;
            that.timer = setInterval(() => {
                that.axios.get('WXCW81/ImportExcelProgress', { params: { taskId: that.taskId } })
                    .then(res => {
                        if (res.data.code !== 101) {
                            that.$message.error(that.errorMessage = res.data.msg);
                            clearInterval(that.timer);
                            that.loadingInstance.close();
                            return;
                        }
                        else {
                            that.loadingInstance.setText(res.data.data.stage + ":" + res.data.data.current + "/" + res.data.data.total);
                            if (res.data.data.errorMessage) {
                                that.$message.error(that.errorMessage = res.data.data.errorMessage);
                                clearInterval(that.timer);
                                that.loadingInstance.close();
                                return;
                            }
                            else if (res.data.data.finished) {
                                that.loadingInstance.close();
                                clearInterval(that.timer);
                                that.$message.success('处理完成');
                                that.successVisible = true;
                            }
                        }
                    }).catch(err => {
                        console.error(err);
                        clearInterval(that.timer);
                    });
            }, 1000);
        }
    },
    beforeDestroy() {
        let that = this;
        clearInterval(that.timer);
    }
};
</script>

<style></style>>